import { Text } from '@kanda-libs/ks-design-library';

import Container from './Title-container';

import { SKELETONS } from '../../LineItem-constants';

const ViewComponent = ({}) => (
  <Container>
    {({ title, isLoading, classNames }) => (
      <Text
        className={classNames.title}
        isLoading={isLoading}
        text={title}
        skeletonProps={SKELETONS.title}
      />
    )}
  </Container>
);

ViewComponent.displayName = 'LineItem-Title-view';

export default ViewComponent;
